module.exports = __webpack_public_path__ + "img/decorator-violin.039ce7e3.png";